/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import './slider';

$(document).ready(() => {
  AOS.init();

  $('.nav-dropdown').attr('data-toggle', 'dropdown');

  // Hamburger Menu
  $('.hamburger').click(function () {
    $(this).toggleClass('is-active');
  });

  $(".is-style-anchor-menu a").on('click', function(event) {
    if ((this.hash !== "") && (this.getAttribute("href").charAt(0) == "#")) {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
        window.location.hash = hash;
      });
    }
  });

  $(".flavor-menu-item").on('click', function(event) {
    if($('#flavor-mobile-menu').css('display') != 'none') {
      $('html,body').animate({scrollTop:$('#flavor-mobile-menu').offset().top}, 500);
    }
  });

  $('.dropdown-menu').click(function(e) {
    e.stopPropagation();
});

$('.nav-primary .dropdown-menu a.dropdown-item').click(function(e) {
  $(this).parents().find('.dropdown-menu').removeClass('show');
});

  $('.sub-menu-toggle').on('click', function(event) {
    $(this).parent().toggleClass('dropdown-is-active');
  });

  if($('.bottle-par-wrap').length > 0) {
  var p_heading = $('.flavor-header-content-inner h1').offset();
  $('.bottle-par-wrap').css("top", p_heading.top );
  }

if ($('.is-style-buy-online-popup').length > 0) {  

  $('#app').append( ' <div class="modal" id="myModal"><div class="modal-content"> <span class="close">&times;</span><iframe id="myframe" name="myframe" src="https://where-to-buy.co/widgets/core/BuyOnlineBuyLocalV2/index.html?pid=12040328" style="width:100%;"></iframe></div></div>' );

$('.is-style-buy-online-popup a').click(function () {
  $('.modal').css("display", "block" );
});

$('.close').click(function () {
  $('.modal').css("display", "none" );
});

} 
});

$(window).scroll(function() {
  if($('.bottle-par-wrap').length > 0) {
    var bottle_base = $('.bottle-par-wrap').offset().top + $('.bottle-par-wrap').height();
    var cocktails_base = $('.popular-cocktails-wrap').offset().top + $('.popular-cocktails-wrap').height();
    var cocktails_c_base = $('.popular-cocktails-wrap').height();
    var bottle_new_base = $('.flavor-content-section').height() - cocktails_c_base;
    var distanceToTop = $('.bottle-par-wrap').offset().top - $(window).scrollTop();
    var p_heading = $('.flavor-header-content-inner h1').offset();


    if ( bottle_base >= cocktails_base ) {
      $('.bottle-par-wrap').css("position", "absolute" );
      $('.bottle-par-wrap').css("top", "auto" );
      $('.bottle-par-wrap').css("bottom", bottle_new_base);
    }
    
    if (distanceToTop > p_heading.top) {
      $('.bottle-par-wrap').css("position", "fixed" );
      $('.bottle-par-wrap').css("bottom", "auto");
      $('.bottle-par-wrap').css("top", p_heading.top );
    }
  }
});
